import { render, staticRenderFns } from "./historiaClinicaConfig.vue?vue&type=template&id=4b3ff011&"
import script from "./historiaClinicaConfig.vue?vue&type=script&lang=js&"
export * from "./historiaClinicaConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports